/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Statistics {
    constructor() {
        this.actionRequestsByStatus = {};
    }
}

export { Statistics };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Statistics.js